var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { env } from '../environment';
import style from '../css/alert_css';
let Alert = class Alert extends LitElement {
    constructor() {
        super(...arguments);
        this.type = '';
        this.aim = '';
    }
    static get styles() {
        if (env.debug) {
            return css ``;
        }
        return [style];
    }
    firstUpdated() {
        const gs1AlertContainer = this.shadowRoot.querySelector('.gs1-alert div:first-child');
        const childArray = Array.from(this.children);
        childArray.forEach((item) => {
            if (!item.hasAttribute('slot')) {
                gs1AlertContainer.appendChild(item);
            }
        });
    }
    updated() {
        this.loadJSIfNotAlreadyLoaded();
    }
    loadJSIfNotAlreadyLoaded() {
        const bs_src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/js/bootstrap.bundle.min.js';
        const bs_integrity = 'sha384-FKyoEForCGlyvwx9Hj09JcYn3nv7wiPVlz7YYwJrWVcXK/BmnVDxM+D2scQbITxI';
        const script = document.createElement('script');
        script.type = 'module';
        script.src = bs_src;
        script.integrity = bs_integrity;
        script.crossOrigin = 'anonymous';
        if (!document.body.querySelector("script[src*='bootstrap'][src$='.js']")) {
            document.getElementsByTagName('body')[0].appendChild(script);
        }
    }
    render() {
        return html `
      ${env.debug
            ? html `<link rel="stylesheet" href="${env.baseUrl}/css/alert.css" />`
            : html ``}
      <div class="alert gs1-alert alert-default is-dismissible is-${this.type}">
        <div></div>
        <slot name="close"></slot>
      </div>
    `;
    }
};
__decorate([
    property()
], Alert.prototype, "type", void 0);
__decorate([
    property({ reflect: true })
], Alert.prototype, "aim", void 0);
Alert = __decorate([
    customElement('gs1-alert')
], Alert);
export { Alert };
//# sourceMappingURL=alert.js.map